import { useEffect } from 'react';
import { useMobileDetect } from '@/hooks/useMobileDetect';

export function useIosModalKeyboardHeight(
  element: HTMLElement | null,
  enabled: boolean
) {
  const { isIos } = useMobileDetect();

  useEffect(() => {
    if (!enabled || !isIos || !element) return;

    const vv = window.visualViewport;

    if (!vv) return;

    let rafId = 0;

    const update = () => {
      const keyboardHeight = Math.max(0, window.innerHeight - vv.height);
      element.style.setProperty(
        '--ios-modal-keyboard-height',
        `${keyboardHeight}px`
      );
    };

    const scheduleUpdate = () => {
      cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(update);
    };

    update();
    vv.addEventListener('resize', scheduleUpdate);
    vv.addEventListener('scroll', scheduleUpdate);

    return () => {
      cancelAnimationFrame(rafId);
      vv.removeEventListener('resize', scheduleUpdate);
      vv.removeEventListener('scroll', scheduleUpdate);
      element.style.removeProperty('--ios-modal-keyboard-height');
    };
  }, [enabled, isIos, element]);
}
